import type IProxyWorkaround from "@/wc/registry/types/proxy-workaround";

export default class StekzHTMLElement extends HTMLElement {
    // Actually below ActionsProxy is used, but because Proxy isn't properly
    // typed: https://github.com/microsoft/TypeScript/issues/20846 yet, we can't
    // use it. We're using a proxy workaround that works in how we are using
    // Proxy.
    actions: IProxyWorkaround;
    nodes: IProxyWorkaround;

    // This is a helper which is set by the customElement decorator, since the
    // usage of the shadowRoot is dynamically determined. Most components use
    // the shadowRoot, but in some cases this is omitted through the
    // 'data-avoid-shadow-root' attribute, which is set in the template of the
    // component utilizing this component.
    target: HTMLElement | ShadowRoot;

    // How often connectedCallback is called.
    connectedCallbackCalledCount: number;
}
